import { NavLink } from "react-router-dom";
import { typeSize } from "@coaching-culture/ui";
import styled from "styled-components";
import { space, SpaceProps } from "styled-system";

type ContainerProps = SpaceProps;

const NavContainer = styled.div<ContainerProps>`
  display: flex;
  max-width: 100%;
  width: 600px;
  border-bottom: 1px solid ${(props) => props.theme.colors.border};
  justify-content: center;
  margin: auto;
  margin-bottom: 24px;
  ${space};
`;

type NavLinksProps = {
  activeColor?: string;
};

const StyledLink = styled(NavLink)<NavLinksProps>`
  background: none;
  border: 0;
  cursor: pointer;
  font-size: ${typeSize("body")};
  font-weight: 500;
  color: ${(props) => props.theme.colors.textMuted};
  border-bottom: 2px solid transparent;
  transform: translateY(1px);
  padding: 10px 16px;
  transition:
    color 0.15s ease,
    border-color 0.15s ease;
  ${space}

  &:hover {
    text-decoration: none;
    color: ${(props) => props.theme.colors.black};
  }

  &:focus {
    outline: 0;
  }

  &:focus-visible {
    outline: 2px solid ${(props) => props.theme.colors.primary};
    outline-offset: -2px;
  }

  &.active {
    color: ${(props) => props.theme.colors.black};
    font-weight: 600;
    border-bottom-color: ${(props) =>
      props.theme.colors[props.activeColor] || props.activeColor};
  }
`;

StyledLink.defaultProps = {
  activeClassName: "active",
  activeColor: "primary",
};

type NavBarProps = {
  links: {
    label: string;
    url: string;
    exact?: boolean;
  }[];
  activeColor?: string;
};

const NavBar = ({ links, activeColor }: NavBarProps) => {
  return (
    <NavContainer>
      {links.map((x, i) => (
        <StyledLink
          to={x.url}
          exact={x.exact}
          activeColor={activeColor}
          key={i}
        >
          {x.label}
        </StyledLink>
      ))}
    </NavContainer>
  );
};

export default NavBar;
